module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/scripts/data/loader-retina.json
// module id = 11
// module chunks = 0